import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'TSF',
  version: 1,
  label: 'Time Series Forecast',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 62,
  inputs: [period('timeperiod', 14)],
  outputs: [line('tsf', 'TSF', COLOR.blue)],
  talib: { functions: ['TSF'], expr: 'TSF(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
